

export const ENSEIGNANT_MES_COURS_INITIATE_AJOUTER_FICHIER = 'ENSEIGNANT_MES_COURS_INITIATE_AJOUTER_FICHIER';
export const ENSEIGNANT_MES_COURS_AJOUTER_FICHIER_START = 'ENSEIGNANT_MES_COURS_AJOUTER_FICHIER_START';
export const ENSEIGNANT_MES_COURS_AJOUTER_FICHIER_SUCCESS = 'ENSEIGNANT_MES_COURS_AJOUTER_FICHIER_SUCCESS';
export const ENSEIGNANT_MES_COURS_AJOUTER_FICHIER_FAIL = 'ENSEIGNANT_MES_COURS_AJOUTER_FICHIER_FAIL';
export const ENSEIGNANT_MES_COURS_AJOUTER_FICHIER_RESET = 'ENSEIGNANT_MES_COURS_AJOUTER_FICHIER_RESET';